import React from 'react';
import PropTypes from 'prop-types';

import classNames from 'classnames';

import { siteLinkData } from 'javascripts/shared/utils/site_link_data';
import { CdnImageUtils } from 'javascripts/shared/utils/cdn_image_utils';
import { bubEvents } from 'shared/events/bub_events';

import styles from 'stylesheets/components/value_prop_section';

export const VALUE_DESCRIPTIONS = [
  {
    title: 'No Subscription Fees',
    description: 'No more monthly membership fees or credits. Listen when you want.',
    imageSlug: 'piggy-bank',
  },
  {
    title: 'New Deals Every Day',
    description: 'Save up to 95% with our curated daily deals.',
    imageSlug: 'flying-money',
  },
  {
    title: 'Money-back Guarantee',
    description: "We know you'll love our audiobooks. Try one today risk free!",
    imageSlug: 'money-bag',
  },
];

export function ValuePropSection({ displayType }) {
  function trackLearnMoreClick() {
    bubEvents.track('Why Shop with Chirp Placement', 'Clicked link', {
      label: 'Learn More',
    });
  }

  function renderHeader() {
    if (displayType === 'light') {
      return (
        <a
          className={styles.header}
          href={siteLinkData.getPath('howItWorks')}
          onClick={trackLearnMoreClick}
          title='Learn More'
        >
          <h3 className={styles.title} aria-hidden='true'>
            Why Shop with Chirp?
          </h3>
          <p className={styles.headerLink} aria-hidden='true'>
            Learn More
          </p>
        </a>
      );
    }

    return (
      <div className={styles.header}>
        <h3 className={styles.title} aria-hidden='true'>
          Why Shop with Chirp?
        </h3>
      </div>
    );
  }

  function renderValueProps() {
    return (
      <div className={styles.values}>
        {_.map(VALUE_DESCRIPTIONS, val => {
          return (
            <div
              className={classNames(
                styles.value,
                displayType === 'light' ? styles.lightValue : styles.darkValue,
              )}
              key={val.imageSlug}
            >
              <img
                className={styles.img}
                src={CdnImageUtils.getOptimizedImage(`logged_out_homepage/${val.imageSlug}`)}
                alt=''
              />
              <div className={styles.text}>
                <p className={styles.valueTitle}>{val.title}</p>
                <p className={styles.valueDescription}>{val.description}</p>
              </div>
            </div>
          );
        })}
      </div>
    );
  }

  return (
    <section
      className={classNames(styles.valuePropSection, { [styles.lightSection]: displayType === 'light' })}
      aria-label='Why Shop with Chirp?'
      data-testid='value-prop-section'
    >
      {renderHeader()}
      {renderValueProps()}
    </section>
  );
}

ValuePropSection.propTypes = {
  displayType: PropTypes.oneOf(['light', 'dark']),
};

ValuePropSection.defaultProps = {
  displayType: 'light',
};
